import { render, staticRenderFns } from "./EtiquetaSelect.vue?vue&type=template&id=1fe268cd"
import script from "./EtiquetaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./EtiquetaSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports